import React, { useState, useRef, useEffect } from "react"
import styles from "./MessengerChatInput.module.scss"

function Textarea({ setValue, valueOfInput, placeholder, onKeyPress }) {
  const [rows, setRows] = useState(1)
  const ref = useRef(null)

  const checkMaxRows = (value) => {
    const width = ref ? ref.current.clientWidth : 0
    const { length } = value
    const r = /\n/g
    const amountOfEnters = value.match(r) ? value.match(r).length : 0
    const amountInOneRow = (width - 6) / 9.9
    const amountOfRows = Math.ceil(
      (length + amountInOneRow * amountOfEnters + 1) / amountInOneRow,
    )

    if (amountOfRows < 5 && amountOfRows > 0) {
      setRows(amountOfRows)
      return
    }
    if (amountOfRows > 4) {
      setRows(4)

      return
    }

    setRows(1)
  }

  useEffect(() => {
    ref.current.focus()
    checkMaxRows(valueOfInput)
  }, [valueOfInput])

  const onChange = (event) => {
    const { value } = event.currentTarget
    checkMaxRows(value)

    setValue(event)
  }

  return (
    <textarea
      rows={rows}
      onChange={onChange}
      value={valueOfInput}
      ref={ref}
      className={styles.textarea}
      placeholder={placeholder}
      maxLength="1000"
      onKeyPress={onKeyPress}
    />
  )
}

export default Textarea
